import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';

import { CLIENT_TYPE } from '../constants';

type GetClientAccessResponse = {
  isActive: boolean;
  clientType: CLIENT_TYPE;
};

const getClientAccessAsync = () => axios.get<GetClientAccessResponse>(`/clients/access`);

export const useGetClientAccessAsync = () =>
  useQuery({
    retry: 3,
    cacheTime: 0,
    queryKey: ['client-access'],
    queryFn: async () => {
      const { data } = await getClientAccessAsync();
      return data;
    },
  });
